import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=7702a3cd"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=7702a3cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports